<template>
    <div class="root">
        <div
            v-if="showButtons"
            class="controls"
        >
            <div
                :class="{canUndo}"
                class="button"
                @click="undo"
            >
                <Undo />
            </div>
            <div
                :class="{canRedo}"
                class="button"
                @click="redo"
            >
                <Redo />
            </div>

            <div
                class="button"
                @click="rotateLeft"
            >
                <RotateLeft />
            </div>
            <div
                class="button"
                @click="rotateRight"
            >
                <RotateRight />
            </div>

            <div
                class="button"
                @click="edit.brightness = true"
            >
                <Brightness />
            </div>

            <div
                class="button"
                @click="edit.contrast = true"
            >
                <Contrast />
            </div>

            <div
                class="button"
                @click="edit.cropping = true"
            >
                <Crop />
            </div>
        </div>

        <div
            v-if="showSlider"
            class="controls"
        >
            <div
                class="button"
                @click="commitSlider"
            >
                <Tick />
            </div>
            <div
                class="button"
                @click="stopSlider"
            >
                <Cross />
            </div>

            <Slider
                :im="im"
                :edit="edit"
            />
        </div>

        <div
            v-if="showCrop"
            class="controls"
        >
            <div
                class="button"
                @click="crop"
            >
                <Tick />
            </div>
            <div
                class="button"
                @click="edit.cropping = false"
            >
                <Cross />
            </div>
        </div>
    </div>
</template>

<script>
import { Slider } from '.';
import {
    Brightness, Contrast, Crop, Cross, Redo, RotateLeft, RotateRight, Tick, Undo
} from '../icons';

export default {
    name: 'Controls',
    components: {
        Slider,
        Brightness,
        Contrast,
        Crop,
        Tick,
        Cross,
        RotateLeft,
        RotateRight,
        Undo,
        Redo
    },
    props: {
        im: {
            type: Function,
            default() {
                return null;
            }
        },
        undo: {
            type: Function,
            required: true
        },
        redo: {
            type: Function,
            required: true
        },
        rotateLeft: {
            type: Function,
            required: true
        },
        rotateRight: {
            type: Function,
            required: true
        },
        edit: {
            type: Object,
            required: true
        },
        crop: {
            type: Function,
            required: true
        },
        stackPos: {
            type: Number,
            required: true
        },
        stack: {
            type: Array,
            required: true
        },
        setBrightness: {
            type: Function,
            required: true
        },
        setContrast: {
            type: Function,
            required: true
        }
    },
    computed: {
        canUndo() {
            return this.stackPos > 0;
        },
        canRedo() {
            return this.stackPos < this.stack.length - 1;
        },
        showButtons() {
            return !this.edit.cropping && !this.edit.brightness && !this.edit.contrast;
        },
        showSlider() {
            return this.edit.brightness || this.edit.contrast;
        },
        showCrop() {
            return this.edit.cropping && !this.showSlider;
        }
    },
    methods: {
        commitSlider() {
            if (this.edit.brightness) {
                this.edit.brightness = false;
                this.setBrightness();
            }

            if (this.edit.contrast) {
                this.edit.contrast = false;
                this.setContrast();
            }
            this.edit.slider = 0;
        },
        stopSlider() {
            this.edit.brightness = false;
            this.edit.contrast = false;
            this.edit.slider = 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.root {
    color: white;
    fill: white;

    .controls {
        display: flex;
        align-items: center;
        height: 32px;
    }

    .button {
        background-color: #333333;
        width: 40px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1px;
        cursor: pointer;
        transition: all .2s;
        padding: 12px;
        box-sizing: border-box;
        user-select: none;

        &:hover {
            background-color: #222244;
        }
    }

    svg {
        height: 32px;
        width: 32px;
    }

    .crop {
        fill: #72a4bd;
    }

    .tick, .save {
        fill: #39c339;
    }

    .cross {
        fill: #d14c4c
    }

    .undo, .redo {
        fill: #777777
    }

    .canUndo, .canRedo {
        svg {
            fill: #ffffff
        }
    }
}
</style>
